import React, { PropTypes } from 'react';
import Image from './Image';
import {v4 as uuidv4} from 'uuid';

export default class Gallery extends React.Component {

	constructor(props) {
		super(props);
		this.state = { selected: {}, selectedIndex: 0 };
	}

	componentDidMount() {
		const { images } = this.props;

		this.setState({selected: images[0]});
	}

	renderLabel() {
		const { label } = this.props;
		return label 
			? <div className="point-label">{label}</div>
			: null;
	}

	render () {	
		const { images, label } = this.props;
		const { selected, selectedIndex } = this.state;

		return (						
			<div className="gallery-container">
				{this.renderLabel()}

				<div className='images-container'>
					<div className="main-image">
						<Image
							key={uuidv4()} // force component remount
							height={label ? "400px" : "450px"}
							src={selected.src||""}
							caption={selected.caption}
						/>
					</div>
					<div className='album'>
						<div className="thumb-container">
							{images.map((image, i) => 
								<div key={i} className={`thumb-item ${i === selectedIndex ? "selected":""}`}>
									<Image 
										src={image.src}
										// maxWidth="160px"
										// maxHeight="100%"
										onClick={() => this.setState({selected: image, selectedIndex: i})}
									/>
								</div>
							)}					
						</div>
					</div>
				</div>
			</div>				
		);
	}
}

Gallery.propTypes = {
	images: PropTypes.array.isRequired,
	label: PropTypes.string
};


// WEBPACK FOOTER //
// ./src/components/Common/Gallery.js